import { defineComponent as _defineComponent } from 'vue'
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  ButtonContainer,
  ButtonPrimary,
  Heading,
  Modal
} from '@warrenbrasil/nebraska-web';
import { computed } from 'vue';
import { useDashStore } from '@/modules/common/store/DashModule';


export default /*#__PURE__*/_defineComponent({
  __name: 'TransparencyModal',
  props: {
    isOpen: { type: Boolean }
  },
  setup(__props: any) {



const theme = useDashStore();

const imageSrc = computed(() =>
  theme.isDarkMode
    ? 'https://warren.com.br/assets/catalog/mockup_dark.png'
    : 'https://warren.com.br/assets/catalog/mockup_light.png'
);

return { __sfc: true,theme, imageSrc, NebraskaColors, BaseText, ButtonContainer, ButtonPrimary, Heading, Modal }
}

})